var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Cotton & Basic Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Cotton & Basic Line",
      "file": "cotton"
    }
  }, [_vm._v(" 싱글/더블 니트와 립, 테리, 트리코트, BCI 코튼 US 코튼, 유기농 코튼, 실켓 코튼과 더불어 다양한 혼방 섬유를 다룹니다. 고급스러운 코튼 원단부터 합리적인 가격의 옵션까지 커버하는 베이직 니트 아이템을 생산합니다. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }